import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import RiskDisclosureNotice from '../features/LegalDocuments/RiskDisclosureNotice';

type Props = {
    setActiveRightTab?: Function;
};

export default function RiskDisclosureNoticeScreen({ setActiveRightTab }: Props) {
    return (
        <ScreenWrapper>
            <RiskDisclosureNotice setActiveRightTab={setActiveRightTab} />
        </ScreenWrapper>
    );
}
